import React from 'react';
export default function CheckboxField({
  id,
  label,
  name,
  checked,
  onChange,
  linkText,
  linkHref = '#',
  className = '',
}) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <input
        id={id}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        className="h-4 w-4 rounded border-slate-300 text-[#FEA12B] focus:ring-[#FEA12B]"
      />
      <label htmlFor={id} className="text-[14px] text-[#1B1C33]">
        {label}
        {linkText && (
          <>
            {' '}
            <a
              href={linkHref}
              className="font-medium text-[#FE8C2B] hover:underline"
            >
              {linkText}
            </a>
          </>
        )}
      </label>
    </div>
  );
}

